import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../../layout/theme-next';

export const styles = makeStyles(() =>
  createStyles({
    root: {
      overflow: 'auto',
    },
    submitButton: {
      '&:hover': {
        backgroundColor: Colors.darkBluish,
      },
    },
  }),
);
